import { render, staticRenderFns } from "./ScClip.vue?vue&type=template&id=ccf0974e"
import script from "./ScClip.vue?vue&type=script&lang=js"
export * from "./ScClip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports